/** @format */

/* eslint-disable */
import React from 'react'
import '../selectables.scss'
import Checkbox from '../../Checkbox/Checkbox'
import { PleaseWait } from '../../Loaders/PleaseWait'

function InvestmentProducts({
  disabled,
  isBusy,
  investmentProductsToBeSelected,
  onCheckInvestmentProduct,
  prefix,
}) {
  const handleCheckInvestmentProducts = (investmentProducts, checkValue) => {
    const com = [...investmentProductsToBeSelected].map(comm => {
      if (comm.id === investmentProducts.id) {
        return { ...comm, checked: checkValue }
      }
      return comm
    })

    onCheckInvestmentProduct(com)
  }

  return (
    <div className="px-4">
      {isBusy ? (
        <PleaseWait />
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {investmentProductsToBeSelected?.map(investmentProduct => (
            <li
              key={investmentProduct.id}
              style={{ listStyle: 'none' }}
              className=" d-flex align-items-center"
            >
              <Checkbox
                id={`${prefix ? prefix : 'com'}-${investmentProduct.id}`}
                checked={investmentProduct.checked}
                disabled={disabled}
                margined
                onCheck={c => {
                  handleCheckInvestmentProducts(investmentProduct, c)
                }}
              />
              <label
                htmlFor={`${prefix ? prefix : 'com'}-${investmentProduct.id}`}
                className={`fw-normal ms-2 cursor-pointer ${
                  investmentProduct.checked ? 'text-primary fw-bold' : ''
                }`}
              >
                {investmentProduct.description}
              </label>
            </li>
          ))}
        </div>
      )}
    </div>
  )
}

export default InvestmentProducts
